<template>
  <div class="About">
    <img class="img" :src="nav" alt="" />
    <div class="text">开奖机会剩余{{ info.chance_num }}次</div>
    <div class="box">
      <img class="box_img me" @click="Myclick()" :src="img.img14" alt="" />
      <img class="box_img kq" @click="show()" :src="img.img15" alt="" />
      <img class="box_img fx" @click="chance(2)" :src="img.img10" alt="" />
    </div>
    <Mod
      v-show="onshow"
      :fx="fx"
      :type="type"
      :info="prize"
      @transfer="getUser"
      @synthesis="aggregate"
    ></Mod>
    <!-- my 我的奖品 -->
    <My v-show="myshow" :info="info" @transfer="Myclick"></My>
  </div>
</template>

<script>
import img from "@/utils/img.js";
import Mod from "@/components/Mod.vue";
import { md5 } from "@/utils/md5.js";
import { keysort, getstring, config, browser } from "@/utils/common.js";
import My from "@/components/My.vue"; //我的奖励弹窗
import { Toast, Dialog } from "vant";
import {
  treasure_index,
  treasure_get_chance,
  treasure_draw_card,
  c_coupon11, //领取关卡优惠券
  c_card11, //领取合成卡
  c_compose11, //集齐3张卡后合
  c_final_coupon11, //领取合成后的优惠券
  c_view11, //浏览活动页面
} from "@/api/index";
export default {
  name: "About",
  components: {
    Mod,
    My,
  },
  data() {
    return {
      nav: "",
      img: img,
      text: "恭喜获得事业卡",
      onshow: false,
      type: true,
      info: {}, //首页数据
      myshow: false, //我的奖励弹窗
      ontype: "", //抽奖类型
      prize: "", //抽出的奖励
    };
  },
  // 创建前
  beforeCreate: function () {},
  // 创建后
  created: function () {
    this.treasure_index();
    if (this.$route.query.type) {
      this.ontype = this.$route.query.type;
      switch (this.$route.query.type) {
        case "1":
          this.nav = this.img.img13;
          break;
        case "2":
          this.nav = this.img.img12;
          break;
        case "3":
          this.nav = this.img.img11;
          break;
        default:
          break;
      }
    }
  },
  activated: function () {},
  // 挂载前
  beforeMount: function () {},
  // 挂载后
  mounted: function () {
    this.ontype = this.$route.query.type;
    c_view11("寻宝活动抽奖页", "https://huodong.yaoking.cn/#/About.html");
  },

  // 更新前
  beforeUpdate: function () {},
  // 更新完成
  updated: function () {},

  methods: {
    // 抽奖
    show() {
      this.card(this.ontype);
    },
    // 调用子组件方法
    getUser(v) {
      this.onshow = v;
    },
    //调用子组件方法 立即合成
    async aggregate() {
      if (this.fx) {
        this.fx = false;
        this.onshow = false;
      }
    },
    // 首页数据
    async treasure_index() {
      let params = {
        member_id: window.sessionStorage.getItem("member_id"),
        timestamp: Date.parse(new Date()) / 1000,
        session: window.sessionStorage.getItem("session"),
        appid: config.appid,
      };
      const sign = md5(getstring(keysort(params)));
      params = {
        ...params,
        sign,
      };
      const { data } = await treasure_index(params);
      this.info = data.info;
    },
    // chance 分享 次数
    async chance(type) {
      //type  1打开，2分享
      if (browser.versions.mobile) {
        //判断是否是移动设备打开
        var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          //在微信中打开
          console.log("微信");
          this.fx = true;
          this.onshow = true;
        }
        if (browser.versions.ios) {
          console.log("ios");
        }
        if (browser.versions.android) {
          console.log("安卓");
        }
      } else {
        //否则就是PC浏览器打开
        console.log("pc");
        Dialog.confirm({
          title: "标题",
          message: "请在app或者小程序中参与活动",
          width: "80% ",
        })
          .then(() => {
            // on confirm
          })
          .catch(() => {
            // on cancel
          });
      }

      let params = {
        member_id: window.sessionStorage.getItem("member_id"),
        timestamp: Date.parse(new Date()) / 1000,
        session: window.sessionStorage.getItem("session"),
        appid: config.appid,
        type: type,
      };
      const sign = md5(getstring(keysort(params)));
      params = {
        ...params,
        sign,
      };
      const { data } = await treasure_get_chance(params);
      if (data.result == "success") {
        this.treasure_index(); //首页数据
      } else if (type == 2) {
        Toast.fail(data.msg);
      }
    },
    // 抽奖
    async card() {
      let that = this;
      let params = {
        member_id: window.sessionStorage.getItem("member_id"),
        timestamp: Date.parse(new Date()) / 1000,
        session: window.sessionStorage.getItem("session"),
        appid: config.appid,
        type: this.ontype,
      };
      const sign = md5(getstring(keysort(params)));
      params = {
        ...params,
        sign,
      };
      let { data } = await treasure_draw_card(params);
      if (data.result == "success") {
        if (data) {
          // alert(data.msg);
          switch (Number(data.info.id)) {
            case 0:
              // 未抽中
              data.img = that.img.img20;
              data.btn = that.img.img23;
              data.text = "未获得奖励";
              break;
            case 1:
              // 未抽中
              data.img = that.img.img20;
              data.btn = that.img.img23;
              data.text = "未获得奖励";
              break;
            case 2:
              // 爱情卡
              data.img = that.img.img17;
              data.text = "恭喜抽中爱情卡";
              data.btn = that.img.img16;
              c_card11("爱情卡");
              break;
            case 3:
              // 黄芪精30元优惠券
              data.img = that.img.img33;
              data.text = "黄芪精30元优惠券";
              data.btn = that.img.img16;
              data.quna = true;
              c_coupon11("黄芪精30元优惠券", data.info.id);
              break;
            case 4:
              // 益安宁丸130元优惠券优惠券
              data.img = that.img.img35;
              data.text = "益安宁丸130元优惠券";
              data.btn = that.img.img16;
              // data.text = "恭喜获得优惠券一张";
              data.quna = true;
              // data.btn = that.img.img16;
              c_coupon11("益安宁丸130元优惠券", data.info.id);
              break;
            case 5:
              //东阿阿胶铁盒12元优惠券
              data.img = that.img.img32;
              data.text = "东阿阿胶铁盒12元优惠券";
              data.btn = that.img.img16;
              data.quna = true;
              c_coupon11("东阿阿胶铁盒12元优惠券", data.info.id);
              break;
            case 6:
              // 天然维生素C5元优惠券
              data.img = that.img.img34;
              data.text = "天然维生素C5元优惠券";
              data.btn = that.img.img16;
              data.quna = true;
              c_coupon11("天然维生素C5元优惠券", data.info.id);
              break;
            case 7:
              data.img = that.img.img20;
              data.btn = that.img.img23;
              data.text = "未获得奖励";
              break;
            case 8:
              // 恭喜抽中事业卡;
              data.img = that.img.img18;
              data.text = "恭喜抽中事业卡";
              data.btn = that.img.img16;
              c_card11("事业卡");
              break;
            case 9:
              // 复方阿胶浆20元优惠券
              data.img = that.img.img38;
              data.text = "复方阿胶浆20元优惠券";
              data.btn = that.img.img16;
              data.quna = true;
              c_coupon11("复方阿胶浆20元优惠券", data.info.id);
              break;
            case 10:
              //雅塑窦利司他胶装10元优惠券
              data.img = that.img.img37;
              data.text = "雅塑窦利司他胶装10元优惠券";
              data.btn = that.img.img16;
              data.quna = true;
              c_coupon11("雅塑窦利司他胶装10元优惠券", data.info.id);
              break;
            case 11:
              // 龙牡壮骨颖粒80元优惠券
              data.img = that.img.img36;
              data.text = "龙牡壮骨颖粒80元优惠券";
              data.btn = that.img.img16;
              data.quna = true;
              c_coupon11("龙牡壮骨颖粒80元优惠券", data.info.id);
              break;
            //
            case 12:
              //  汤臣倍健蛋白粉30元优惠券:
              data.img = that.img.img39;
              data.text = "汤臣倍健蛋白粉30元优惠券";
              data.btn = that.img.img16;
              data.quna = true;
              c_coupon11("汤臣倍健蛋白粉30元优惠券", data.info.id);
              break;
            case 13:
              data.img = that.img.img20;
              data.btn = that.img.img23;
              data.text = "未获得奖励";
              break;
            case 14:
              // 恭喜获得健康卡一张
              data.img = that.img.img19;
              data.btn = that.img.img16;
              data.text = "恭喜获得健康卡一张";
              c_card11("健康卡");
              break;
            case 15:
              // 米诺地尔酊10元优惠
              data.img = that.img.img42;
              data.text = "恭喜获得米诺地尔酊10元优惠一张";
              data.btn = that.img.img16;
              data.quna = true;
              c_coupon11("米诺地尔酊10元优惠", data.info.id);
              break;
            case 16:
              // 燕窝50优惠券
              data.text = "恭喜获得燕窝50元优惠券一张";
              data.btn = that.img.img16;
              data.img = that.img.img43;
              data.quna = true;
              c_coupon11("燕窝50元优惠券", data.info.id);
              break;
            case 17:
              // 肾宝片10元优惠券
              data.text = "恭喜获得肾宝片10元优惠券一张";
              data.btn = that.img.img16;
              data.img = that.img.img44;
              data.quna = true;
              c_coupon11("肾宝片10元优惠券", data.info.id);
              break;
            case 18:
              // 阿胶50优惠券
              data.text = "恭喜获得阿胶50元优惠券一张";
              data.btn = that.img.img16;
              data.img = that.img.img45;
              data.quna = true;
              c_coupon11("阿胶50优惠券优惠券", data.info.id);
              break;
            case 19:
              // 10通用优惠券
              data.text = "恭喜获得10元优惠券一张";
              data.btn = that.img.img16;
              data.img = that.img.img41;
              // data.quna = true;
              c_compose11("10通用优惠券");
              c_final_coupon11("10通用优惠券", data.info.id);
              break;
            case 20:
              // 1000
              data.img = that.img.img25;
              data.btn = that.img.img16;
              data.text = "恭喜获得1000元现金";
              c_compose11("1000元现金");
              c_final_coupon11("1000元现金", data.info.id);
              break;
            case 21:
              // 黄金转运珠
              data.img = that.img.img26;
              data.btn = that.img.img16;
              data.text = "恭喜获得黄金转运珠";
              c_compose11("黄金转运珠");
              c_final_coupon11("黄金转运珠", data.info.id);
              break;
            case 22:
              // 1000
              data.img = that.img.img27;
              data.btn = that.img.img16;
              data.text = "恭喜获得养生堂护手霜";
              c_compose11("养生堂护手霜");
              break;
            case 23:
              // 薇诺娜面膜礼盒
              data.img = that.img.img28;
              data.btn = that.img.img16;
              data.text = "恭喜获得薇诺娜面膜礼盒";
              c_compose11("薇诺娜面膜礼盒");
              c_final_coupon11("薇诺娜面膜礼盒", data.info.id);
              break;
            case 24:
              // 50通用优惠券
              data.text = "恭喜获得50元优惠券一张";
              data.btn = that.img.img16;
              data.img = that.img.img40;
              // data.quna = true;
              c_compose11("50元通用优惠券");
              c_final_coupon11("50元通用优惠券", data.info.id);
              break;
            default:
              data.id = 0;
              data.img = that.img.img20;
              data.btn = that.img.img23;
              break;
          }
          that.prize = data;
          that.onshow = !that.onshow;
          // console.log(that.prize, "++++");
        } else {
          console.log(data);
        }
      } else {
        Toast.fail(data.msg);
      }
      this.treasure_index();
    },
    Myclick() {
      this.myshow = !this.myshow;
      this.treasure_index();
    },
  },
};
</script>
<style scoped>
.About {
  width: 100%;
  height: 100vh;
  background-image: url("https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/About/bj-min.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}
.img {
  position: absolute;
  top: 23vh;
  left: 0;
  right: 0;
  margin: auto;
  width: 180px;
  height: 30px;
}
.text {
  font-size: 14px;
  width: 60%;
  position: absolute;
  bottom: 15vh;
  text-align: center;
  left: 0;
  right: 0;
  margin: auto;
  color: #fff;
}
.box {
  width: 80%;
  position: absolute;
  bottom: 5vh;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.me {
  width: 50px;
  /* height: 20px; */
}
.fx {
  width: 50px;
  /* height: 20px; */
}
.kq {
  width: 120px;
  margin: 0 10px;
}
</style>